import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';

const $testResultRoutineSlider = document.querySelectorAll('[data-role=test-result-row]');
const $routineList = document.querySelectorAll('[data-role=routine-list]');
const isMobile = window.matchMedia('(max-width: 767px)').matches;
const isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches;
const $cards = document.querySelectorAll('[data-role=cards]');
const $serums = document.querySelectorAll('[data-role=serums]');
const $bestsellers = document.querySelector('[data-role=bestsellers-products-slider]') as HTMLElement;

$testResultRoutineSlider.forEach(($el) => {
	const testResultRoutineSwiper = new Swiper($el as HTMLElement, {
		modules: [Navigation],
		slidesPerView: isMobile || isTablet ? 1.18 : 2,
		spaceBetween: isMobile || isTablet ? '12px' : '84px',
		navigation: {
			nextEl: $el.querySelector('[data-role=next-button-routine]') as HTMLElement ?? null,
			prevEl: $el.querySelector('[data-role=prev-button-routine]') as HTMLElement ?? null,
		}
	});

	window.addEventListener('goToFirstSlideResultRoutine', () => {
		testResultRoutineSwiper.slideTo(0);
	});

	if (isMobile) {
		const innerSwipers = $el.querySelectorAll('[data-role=test-result-images]');

		innerSwipers.forEach(($innerEl) => {
			new Swiper($innerEl as HTMLElement, {
				nested: true,
				touchStartPreventDefault: false,
				modules: [Pagination],
				slidesPerView: 1,
				loop: false,
				pagination: {
					el: $innerEl.querySelector('[data-role=routine-images-paginations]') as HTMLElement ?? null,
					clickable: true,
				},
			});
	
			$innerEl.addEventListener('touchstart', () => {
				testResultRoutineSwiper.allowTouchMove = false;
			});

			$innerEl.addEventListener('touchend', () => {
				testResultRoutineSwiper.allowTouchMove = true;
			});
		});
	}
});

if (isMobile) {
	$routineList.forEach(($el) => {
		new Swiper($el as HTMLElement, {
			slidesPerView: 1.11,
			spaceBetween: '16px',
			loop: false,
		});
	});
}

$cards.forEach(($el) => {
	new Swiper($el as HTMLElement, {
		modules: [Navigation],
		slidesPerView: 1.125,
		spaceBetween: '20px',
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: '20px',
			},
			1025: {
				slidesPerView: 3,
				spaceBetween: '20px',
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: '20px',
			}
		},
		navigation: {
			nextEl: $el.querySelector('[data-role=next-button]') as HTMLElement ?? null,
			prevEl: $el.querySelector('[data-role=prev-button]') as HTMLElement ?? null,
		}
	});
});

$serums.forEach(($el) => {
	new Swiper($el as HTMLElement, {
		modules: [Navigation],
		slidesPerView: 1.21,
		spaceBetween: '16px',
		breakpoints: {
			768: {
				slidesPerView: 1.21,
				spaceBetween: '16px',
			},
			1025: {
				slidesPerView: 2,
				spaceBetween: '32px',
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: '32px',
			}
		},
		navigation: {
			nextEl: $el.querySelector('[data-role=next-button]') as HTMLElement ?? null,
			prevEl: $el.querySelector('[data-role=prev-button]') as HTMLElement ?? null,
		}
	});
});

new Swiper($bestsellers as HTMLElement, {
	modules: [Navigation],
	slidesPerView: 1.48,
	spaceBetween: '16px',
	breakpoints: {
		768: {
			slidesPerView: 2.5,
			spaceBetween: '30px',
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: '35px',
		},
		1200: {
			slidesPerView: 4,
			spaceBetween: '35px',
		}
	},
	navigation: {
		nextEl: $bestsellers.querySelector('[data-role=next-button]') as HTMLElement ?? null,
		prevEl: $bestsellers.querySelector('[data-role=prev-button]') as HTMLElement ?? null,
	}
});